var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-hints",class:{ webview : _vm.fromWebView },style:({ visibility: !_vm.hints.length ? 'hidden' : 'visible' })},_vm._l((_vm.hints),function(hint,index){return _c('button',{key:hint + index,staticClass:"message-hint",on:{"click":function($event){return _vm.sendHint(hint)}}},[_vm._v(" "+_vm._s(hint)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }